export const SET_PENDING = "state/battery-pickups/SET_PENDING";
export const SET_TOUCHED = "state/battery-pickups/SET_TOUCHED";
export const SET_BATTERY_PICKUPS = "state/battery-pickups/SET_BATTERY_PICKUPS";
export const FORGET_BATTERY_PICKUPS =
  "state/battery-pickups/FORGET_BATTERY_PICKUPS";
